import { Backdrop, Button, Divider, InputLabel, Modal } from "@mui/material";
import styles from "./FilterModal.module.scss";
import dayjs, { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import Mark from "../../assets/images/u-mark.svg";
import Times from "../../assets/images/u_multiply (1).svg";
import Grid from "@mui/system/Unstable_Grid/Grid";

interface FilterModalProps {
  setEventDate?: React.Dispatch<React.SetStateAction<string>>;
  dropdown: boolean;
  setDropdown: React.Dispatch<React.SetStateAction<boolean>>;
  setFromDate?: React.Dispatch<
    React.SetStateAction<dayjs.Dayjs | null | string>
  >;
  setToDate?: React.Dispatch<React.SetStateAction<dayjs.Dayjs | null | string>>;
  eventDate?: string;
  fromDate?: dayjs.Dayjs | null | string;
  toDate?: dayjs.Dayjs | null | string;
  filteredArray?: {
    name: string;
    value: any;
    setValue: React.Dispatch<React.SetStateAction<any>>;
    selective?: any;
    selectHelper?: boolean;
    type?: string;
  }[];
  setBearer?: React.Dispatch<React.SetStateAction<boolean>>;
  clearHandler?: () => void;
  oneDate?: boolean;
}

const FilterModal = ({
  setEventDate,
  dropdown,
  oneDate,
  setDropdown,
  setFromDate,
  setToDate,
  toDate,
  fromDate,
  eventDate,
  setBearer,
  clearHandler,
  filteredArray
}: FilterModalProps) => {
  const handleClick = (event: any) => {
    setEventDate?.(event.currentTarget.getAttribute("data-value"));
  };

  const fromDateHandler = (newValue: Dayjs | null) => {
    setFromDate?.(dayjs(newValue).format("YYYY-MM-DD"));
  };

  const toDateHandler = (newValue: Dayjs | null) => {
    setToDate?.(dayjs(newValue).format("YYYY-MM-DD"));
  };

  const applyHandler = () => {
    setDropdown(false);
    setBearer?.(true);
  };

  return (
    <div className={styles.modalwrapper}>
      <div className={styles.modalhead}>
        <span className={styles.modalheadh3}>Filters</span>
      </div>
      <Divider style={{ margin: 0, padding: 0 }} />
      <div
        style={{
          padding: "32px 24px"
        }}
      >
        <div className={styles.dateWrapper}>
          <p className={styles.dateWrapper_p}>Date range</p>
          <div className={styles.dateWrapper_content}>
            <button
              className={styles.dateWrapper_contentbutton}
              style={{
                color: eventDate === "today" ? "#27AE60" : "#828282",
                background: "#FFFFFF",
                border:
                  eventDate === "today"
                    ? "1px solid #27AE60"
                    : "1px solid #DDDDDD"
              }}
              onClick={handleClick}
              data-value="today"
            >
              Today
            </button>
            <button
              className={styles.dateWrapper_contentbutton}
              style={{
                color: eventDate === "last7days" ? "#27AE60" : "#828282",
                background: "#FFFFFF",
                border:
                  eventDate === "last7days"
                    ? "1px solid #27AE60"
                    : "1px solid #DDDDDD"
              }}
              onClick={handleClick}
              data-value="last7days"
            >
              Last 7 days
            </button>
            <button
              className={styles.dateWrapper_contentbutton}
              style={{
                color: eventDate === "last30days" ? "#27AE60" : "#828282",
                background: "#FFFFFF",
                border:
                  eventDate === "last30days"
                    ? "1px solid #27AE60"
                    : "1px solid #DDDDDD"
              }}
              onClick={handleClick}
              data-value="last30days"
            >
              30 days
            </button>
            <button
              className={styles.dateWrapper_contentbutton}
              style={{
                color: eventDate === "oneyear" ? "#27AE60" : "#828282",
                background: "#FFFFFF",
                border:
                  eventDate === "oneyear"
                    ? "1px solid #27AE60"
                    : "1px solid #DDDDDD"
              }}
              onClick={handleClick}
              data-value="oneyear"
            >
              1 year
            </button>
          </div>
        </div>

        <div className={styles.customDate}>Custom Date Range</div>
        {oneDate ? (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div
              style={{
                maxHeight: "1rem"
              }}
            >
              <MobileDatePicker
                label="Date"
                inputFormat="MM/DD/YYYY"
                disableFuture
                value={fromDate}
                onChange={fromDateHandler}
                renderInput={(params: any) => (
                  <TextField
                    {...params}
                    id="standard-basic"
                    variant="standard"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </div>
          </LocalizationProvider>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div
                style={{
                  marginLeft: "0px",
                  maxHeight: "1rem"
                }}
              >
                <MobileDatePicker
                  label="Start date"
                  inputFormat="MM/DD/YYYY"
                  disableFuture
                  value={fromDate}
                  onChange={fromDateHandler}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      id="standard-basic"
                      variant="standard"
                      size="small"
                    />
                  )}
                />
              </div>

              <div
                style={{
                  marginLeft: "16px"
                }}
              >
                <MobileDatePicker
                  label="End date"
                  inputFormat="MM/DD/YYYY"
                  disableFuture
                  value={toDate}
                  onChange={toDateHandler}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      id="standard-basic"
                      variant="standard"
                      size="small"
                    />
                  )}
                />
              </div>
            </LocalizationProvider>
          </div>
        )}

        <div
          style={{
            margin: "27px 0px"
          }}
        >
          {filteredArray?.map(
            ({ name, value, selective, setValue, selectHelper, type }, i) => (
              <div
                key={i}
                style={{
                  marginBottom: "1rem"
                }}
              >
                {!selective || selective?.length <= 0 ? (
                  type === "text" ? (
                    <>
                      <TextField
                        label={name}
                        name={name}
                        variant="outlined"
                        margin="none"
                        type="text"
                        size="small"
                        value={value}
                        onChange={(e: any) => setValue(e.target.value)}
                        sx={{ fontSize: "14px", margin: "0.6rem 0" }}
                        fullWidth
                      />
                    </>
                  ) : (
                    <>
                      <TextField
                        label={name}
                        name={name}
                        variant="outlined"
                        margin="none"
                        type="text"
                        size="small"
                        value={value}
                        onChange={(e: any) => setValue(e.target.value)}
                        fullWidth
                      />
                    </>
                  )
                ) : (
                  <div className={styles.select}>
                    <select
                      value={value}
                      onChange={(e: any) => setValue(e.target.value)}
                      className={styles.select_text}
                      required
                    >
                      <option key={i} value="">
                        **Select**
                      </option>
                      {selective?.map(
                        (
                          { name, value }: { name: any; value: any },
                          i: any
                        ) => (
                          <option key={i} value={selectHelper ? name : value}>
                            {name}
                          </option>
                        )
                      )}
                    </select>
                    {/* <span className={styles.select_highlight}></span> */}
                    {/* <span className={styles.select_bar}></span> */}
                    <label className={styles.select_label}>{name}</label>
                  </div>
                )}
              </div>
            )
          )}
        </div>

        <div className={styles.buttonwrapper}>
          <button
            onClick={clearHandler}
            className={styles.Downloadbutton_faint}
          >
            Clear filter
          </button>

          <button onClick={applyHandler} className={styles.Downloadbutton}>
            Apply filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
